import { render } from "./Brand.vue?vue&type=template&id=bc57fbd0&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"

import "./Brand.vue?vue&type=style&index=0&id=bc57fbd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc57fbd0"]])

export default __exports__